<template>
  <footer class="footer">
    <Jumbo class="footer__nav" size="fit">
      <template #background></template>

      <template #before>
        <a href="/"><Logo white class="footer__logo"/></a>
      </template>

      <template #after>
        <div class="footer__navigation">
          <nav v-for="(item, index) in elements" :key="index">
            <ul>
              <li v-for="(val, key) in item" :key="key" class="footer__link">
                <a :href="val">{{ key }}</a>
              </li>
            </ul>
          </nav>
        </div>
      </template>
    </Jumbo>

    <Jumbo size="fit" class="footer__externals" reverseOnMobile>
      <template #before>
        <Entities />
      </template>
      <template #after>
        <SocialLinks />
      </template>
    </Jumbo>

    <Jumbo class="footer__legal" size="fit" reverseOnMobile>
      <template #background></template>

      <template #before>
        <p class="footer__copyright">© {{ year }} Trioteca</p>
      </template>

      <template #after>
        <nav aria-label="Asuntos legales">
          <ul>
            <li><a href="/legal/politica-de-privacidad">Política de privacidad</a></li>
            <li><a href="/legal/aviso-legal-y-condiciones-generales">Términos y condiciones</a></li>
            <li><a href="/legal/politica-de-cookies">Política de cookies</a></li>
            <li><a href="#cookies-manager" @click.prevent="openCookiesManager">Configurar cookies</a></li>
          </ul>
        </nav>
      </template>
    </Jumbo>
  </footer>
</template>

<script>
import Jumbo from '@/lego/components/layout/Jumbo.vue';
import Icon from '@/lego/components/icons/Icon.vue';
import Entities from '@/lego/partials/Entities.vue';
import SocialLinks from '@/lego/partials/SocialLinks.vue';
import route from '@/route.js';
import Logo from '@/lego/components/layout/Logo.vue';
import CookiesBus from '@/lego/utils/bus/cookies';

export default {
  components: {
    Jumbo,
    Icon,
    Entities,
    SocialLinks,
    Logo,
  },
  setup() {
    return {
      elements: [
        { Glosario: route('help.glossary'), 'Preguntas frecuentes': route('help.faqs'), 'Trabaja con nosotros': route('about') },

        {
          'Simular una nueva hipoteca': route('new-mortgage-page.index'),
          'Mejorar mi hipoteca actual': route('funnel.improve'),
          'Tasación oficial': route('official-appraisal.view'),
        },
      ],
      year: new Date().getFullYear(),
      openCookiesManager: () => {
        CookiesBus.emit('manager.open');
      },
    };
  },
};
</script>

<style lang="postcss" scoped>
.footer {
  /deep/.jumbo__background {
    @apply bg-brand-secondary-dark;
  }

  &__logo {
    @apply w-[12rem];
  }

  &__nav {
    /deep/.jumbo__content {
      @apply lg:items-start py-lg lg:py-[4.5rem] md:justify-between flex-col lg:flex-row gap-md 2xl:px-[13.5rem] xl:px-[7.5rem] lg:px-sm;
    }
  }

  &__navigation {
    @apply flex lg:flex-row lg:gap-xxl gap-xxxs flex-col;

    ul {
      @apply space-y-xxxs;
    }
  }

  &__link {
    @apply text-neutral-white lg:text-left text-center;

    &:last-child {
      grid-column: 2;
    }
  }

  &__legal {
    @apply flex flex-col lg:flex-row-reverse items-center lg:justify-between w-full;

    ul {
      @apply flex flex-col lg:flex-row lg:justify-between items-center style-overline text-neutral-grayish lg:gap-[2.25rem] gap-nano;
    }

    /deep/.jumbo__content {
      @apply 2xl:mx-[13.5rem] xl:mx-xl lg:mx-sm py-md lg:py-xxs my-0 flex-col-reverse md:justify-between lg:flex-row border-t-hairline border-brand-secondary-lightest px-0 gap-xxxs;
    }
  }

  &__copyright {
    @apply style-body-sm text-brand-secondary-lightest;
  }

  &__externals {
    @apply w-full;

    /deep/.jumbo__content {
      @apply lg:items-start py-lg lg:py-[4.5rem] md:justify-between flex-col lg:flex-row gap-md 2xl:px-[13.5rem] xl:px-[7.5rem] lg:px-sm;
    }
  }
}
</style>
